import { http } from "@/communication";

const balanceModule = {
  namespaced: true,
  state: {
    balance: 0
  },
  actions: {
    read({ commit }) {
      return http
        .get("/api/v1/balance")
        .then(({ data }) => {
          commit("update", data);
        })
        .catch(error => {
          console.log(`${name}s error`, error);
        });
    }
  },
  mutations: {
    update(state, balance) {
      state.balance = balance;
    },
    newTransaction(state, transaction) {
      state.balance = transaction.total;
    }
  },
  getters: {
    balance: state => state.balance
  }
};

export default balanceModule;
